import React from "react";
import classnames from "classnames";
import Styles from "./EllipsisTooltip.module.scss";

interface ellipsisTooltipProps {
    textValue: string;
    greaterThanValue: number;
    styles?: React.CSSProperties;
    mainClass?: string;
    defaultValueClassName?: string;
    toolTipClassName?: string;
}

const EllipsisTooltip = ({
    textValue = "",
    greaterThanValue,
    styles,
    mainClass,
    defaultValueClassName,
    toolTipClassName
}: ellipsisTooltipProps) => {
    return (
        <span
            className={classnames(
                mainClass,
                textValue.length > greaterThanValue ? Styles.ellipsisTooltip : Styles.noTooltip
            )}
            style={styles}
        >
            <span className={classnames(Styles.defaultValue, defaultValueClassName)}>{textValue}</span>
            <span className={classnames(Styles.tooltip, toolTipClassName)}>{textValue}</span>
        </span>
    );
};

export default EllipsisTooltip;
